define('app/views/minicart_item_view',['app/setup'], function(takhfifan) {

  takhfifan.MinicartItemView = Backbone.View.extend({

    template: ( $('#minicart-item-template').length > 0 ) ?
      _.template( $('#minicart-item-template').html() ) : '',

    events: {
      'click a.item-delete' : 'removeItem'
    },

    initialize: function() {
      var _this = this;
      this.render();

      this.model.on('destroy', function(){
        _this.$el.slideUp(function(){
          _this.remove();
        });
      });

    },

    render: function() {
      this.$el.html( this.template( this.model.toJSON() ) );
    },

    removeItem: function(event) {
      event.preventDefault();
      this.model.remove();
    }
  });
});

